export const ALL = 'all';
export const PEOPLE = 'people';
export const TEAMS = 'teams';
export const LOCATIONS = 'locations';

export const TABS_LIST = [ALL, PEOPLE, TEAMS, LOCATIONS];
